import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import api from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'
import { signatureUserKey } from '../helpers/signature-query-key'

type SignatureDTO = any
type Options = Omit<
  UseQueryOptions<SignatureDTO, unknown, SignatureDTO, ReturnType<typeof signatureUserKey>>,
  'queryKey' | 'queryFn'
>

export function useFetchSignatureByIdUserView(id_user?: string, options?: Options) {
  const token = useAccessToken()

  return useQuery({
    queryKey: signatureUserKey(id_user),
    queryFn: async () => {
      if (!id_user) throw new Error('Signature ID_user is required')
      const { data } = await api.get(`/signatures/viewUser/${id_user}`, {
        headers: { Authorization: `Bearer ${token}` }
      })
      if (!data?.data) throw new Error('Signature not found')
      return data.data as SignatureDTO
    },
    placeholderData: undefined,
    staleTime: 0,
    refetchOnMount: 'always',
    refetchOnWindowFocus: false,
    gcTime: 1000 * 60 * 5,

    enabled: Boolean(id_user) && (options?.enabled ?? true),

    select: raw => (structuredClone ? structuredClone(raw) : JSON.parse(JSON.stringify(raw))),

    // permita override seguro de algumas opções
    retry: options?.retry ?? 1
  })
}
